<template>
    <rkm-modal
        :buttons="buttons"
        :loading="loading"
        title="Assinatura eletrônica"
        @save="$refs.Form.handleAssinatura()"
        extraLarge
        ref="Modal"
    >
        <Form
            :item="item"
            @handleShowSave="handleShowSave"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        buttons() {

            return this.buttonSave ? ['cancel', 'save'] : ['cancel']
        },
    },
    data: () => ({
        item: [],
        buttonSave: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.item = item
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        handleShowSave(value) {

            this.buttonSave = value
        }
    },
}
</script>